import {
  ADD_ROLE_FAIL,
  ADD_ROLE_SUCCESS,
  DELETE_ROLE_FAIL,
  DELETE_ROLE_SUCCESS,
  GET_ROLE_DETAILS_FAIL,
  GET_ROLE_DETAILS_SUCCESS,
  GET_ROLE_FAIL,
  GET_ROLE_SUCCESS,
  RESET_ROLE_ATTACHMENT_STATE,
  RESET_ROLE_STATE,
  ROLE_USER_ASSIGN_FAIL,
  ROLE_USER_ASSIGN_SUCCESS,
  UPDATE_ROLE_FAIL,
  UPDATE_ROLE_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
  role: [],
  roleDetails: [],
  addRole: [],
  editRole: [],
  delRole: [],
  roleUserAssign: [],
  error: [],
}

const Role = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ROLE_SUCCESS:
      return {
        ...state,
        role: action.payload,
      }

    case GET_ROLE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_ROLE_DETAILS_SUCCESS:
      return {
        ...state,
        roleDetails: action.payload,
      }

    case GET_ROLE_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_ROLE_SUCCESS:
      return {
        ...state,
        addRole: action.payload,
        roleDetails: action.payload.data,
      }

    case ADD_ROLE_FAIL:
      return {
        ...state,
        error: action.payload,
        addRole: action.payload,
      }

    case UPDATE_ROLE_SUCCESS:
      return {
        ...state,
        roleDetails: action.payload.data,
        editRole: action.payload,
      }

    case UPDATE_ROLE_FAIL:
      return {
        ...state,
        error: action.payload,
        editRole: action.payload,
      }

    case DELETE_ROLE_SUCCESS:
      return {
        ...state,
        delRole: action.payload,
      }

    case DELETE_ROLE_FAIL:
      return {
        ...state,
        error: action.payload,
        delRole: action.payload,
      }

    case ROLE_USER_ASSIGN_SUCCESS:
      return {
        ...state,
        roleUserAssign: action.payload,
        roleDetails: action.payload.data
      }

    case ROLE_USER_ASSIGN_FAIL:
      return {
        ...state,
        error: action.payload,
        roleUserAssign: action.payload,
      }
    case RESET_ROLE_STATE:
      return {
        ...state,
        addRole: [],
        editRole: [],
        delRole: [],
        roleUserAssign: [],
        error: [],
      }
    case RESET_ROLE_ATTACHMENT_STATE:
      return {
        ...state,
        roleUserAssign: [],
        error: [],
      }
    default:
      return state
  }
}

export default Role
